'use strict';

exports.__esModule = true;
exports.default = undefined;

var _HeadGoverness2 = require('./HeadGoverness');

var _HeadGoverness3 = _interopRequireDefault(_HeadGoverness2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Very easy governess who lets everything happen unguarded.
 */
var EasyGoverness = function (_HeadGoverness) {
  _inherits(EasyGoverness, _HeadGoverness);

  function EasyGoverness() {
    var _ref;

    _classCallCheck(this, EasyGoverness);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = _possibleConstructorReturn(this, (_ref = EasyGoverness.__proto__ || Object.getPrototypeOf(EasyGoverness)).call.apply(_ref, [this].concat(args)));

    _this.unguarded = true;
    return _this;
  }

  return EasyGoverness;
}(_HeadGoverness3.default);

exports.default = EasyGoverness;


//////////////////
// WEBPACK FOOTER
// ./~/kindergarten/lib/governesses/EasyGoverness.js
// module id = uTQj
// module chunks = 0